module.exports = __webpack_public_path__ + "img/证书2.911612b4.jpg";